import { publishActiveTab } from "../../../../../../redux/features/cars/carsSlice";
import { useAppDispatch } from "../../../../../../redux/hooks";
import instantWinStyles from "../ourInstantWin.module.css";
import { InstantWinPrize } from "../types";
import carStyles from "../../ourCars/ourCars.module.css";
import { MouseEvent, useState } from "react";
import Modal from "../../../../../../components/Modal/modal";
import InstantWinWinnerPopup from "./instantWinWinnerPopup";

const InstantWinPrizeTile = ({
  showTabbedVersion,
  prize,
  competitionId,
}: {
  showTabbedVersion: boolean;
  prize: InstantWinPrize;
  competitionId: number;
}) => {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const progressBarPercent = (prize.totalWonPrizes * 100) / prize.totalPrizes;
  const barWidth =
    progressBarPercent > 0 && progressBarPercent < 10
      ? "w-[10%]"
      : `w-[${Math.floor(progressBarPercent * Math.pow(10, -1)) / Math.pow(10, -1)}%]`;

  const showInstantWinWinnersFromListing = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setShowModal(true);
  };

  const getEnterNowText = () => {
    if (showTabbedVersion) {
      return (
        <span className={instantWinStyles.enterNow} onClick={() => dispatch(publishActiveTab({ value: "prizes" }))}>
          ENTER NOW &raquo;
        </span>
      );
    } else {
      return (
        <a className={instantWinStyles.enterNow} href="/app/(general-header)/prizes/lifestyle/play-instant-win">
          ENTER NOW &raquo;
        </a>
      );
    }
  };
  return (
    <>
      <div className={`bg-white ${instantWinStyles.cardTile} ${carStyles.cardTile}`}>
        <div className={`${instantWinStyles.instanWinIcon} absolute top-0 flex justify-center items-center`}>
          <svg
            className="absolute left-[11px] top-[4px]"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.8702 6.0978C11.8287 6.01342 11.7432 5.95967 11.6492 5.95842L8.64048 5.92067L10.012 0.983546C10.0446 0.866546 9.98836 0.743046 9.87861 0.690921C9.76911 0.638546 9.63773 0.672671 9.56736 0.771796L4.15061 8.3968C4.09648 8.47305 4.08948 8.57317 4.13236 8.65617C4.17536 8.7393 4.26098 8.79155 4.35448 8.79155H6.68336L4.78211 15.0102C4.74661 15.1264 4.79986 15.2514 4.90823 15.3063C4.94423 15.3245 4.98298 15.3333 5.02111 15.3333C5.09786 15.3333 5.17298 15.2979 5.22161 15.2328L11.8466 6.3578C11.9027 6.28267 11.9119 6.18205 11.8702 6.0978Z"
              fill="#F2F2F2"
            />
          </svg>
        </div>
        <img src={prize.thumbnailImageUrl} alt={`${prize.contentNodeId}`} className={carStyles.carImage} />
        <h1 className={carStyles.cardTitle}>{prize.make}</h1>
        <h2 className={`${carStyles.cardSubtitle} mt-1`}>{prize.model}</h2>
        <div className={instantWinStyles.divider}>
          <span className={`${instantWinStyles.cut} left-0`}></span>
          <div className={instantWinStyles.dline}></div>
          <span className={`${instantWinStyles.cut} right-0`}></span>
        </div>
        <div className="flex justify-between">
          <div className="flex prizesWon flex-col">
            <div className="flex">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="#FF8200" />
              </svg>
              <span className="ml-1 leading-[0.5] text-[14px] text-[#898994]">Won</span>
            </div>
            <span className="font-jost text-[24px] font-normal text-[#696971]">{prize.totalWonPrizes}</span>
          </div>
          <div className="flex prizesLeft flex-col">
            <div className="flex">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4" cy="4" r="4" fill="#FFD8B0" />
              </svg>
              <span className="ml-1 leading-[0.5] text-[14px] text-[#898994]">Left</span>
            </div>
            <span className="font-jost text-[24px] font-normal text-[#696971]">
              {prize.totalPrizes - prize.totalWonPrizes}
            </span>
          </div>
        </div>
        <div className="w-full bg-[#ffd8b0] rounded-full h-2 mt-2">
          <div className={`bg-[#ff8200] h-2 rounded-full ${barWidth}`}></div>
        </div>
        <div className="flex justify-around mt-5">
          <span className={instantWinStyles.showWinners} onClick={showInstantWinWinnersFromListing}>
            Show Winners &raquo;
          </span>
          {getEnterNowText()}
        </div>
      </div>
      <Modal
        body={
          <InstantWinWinnerPopup
            make={prize.make}
            model={prize.model}
            amountWon={prize.totalWonPrizes}
            amountLeft={prize.totalPrizes - prize.totalWonPrizes}
            imageURL={prize.thumbnailImageUrl}
            barWidth={barWidth}
            prizeId={prize.contentNodeId}
            competitionId={competitionId}
          />
        }
        closeModal={event => {
          event.stopPropagation();
          setShowModal(false);
        }}
        isOpen={showModal}
        modalClassNames="md:rounded-b-none md:rounded-t-2xl xs:w-full py-8 md:px-12 xs:px-4"
        title=""
        modalWidth="md:w-[683px]"
        modalHeight="h-[566px]"
        footerElementOutsideModalBody={
          <div className="md:w-[683px] p-3 bg-[#f2f2f2] flex justify-center items-center xs:w-full">
            <a
              href="/app/(general-header)/prizes/lifestyle/play-instant-win"
              className="text-[#ff8200] font-jost text-[20px] hover:underline">
              ENTER NOW &raquo;
            </a>
          </div>
        }
      />
    </>
  );
};

export default InstantWinPrizeTile;
